/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-12-23 08:54:32
 */
export default {
  path: '/',
  name: 'nationsJudges',
  meta: {
    title: '国家评委库',
    level: 1,
    nav: 'nationsJudges',
    role: ['admin', 'topunion'],
    icon: 'fa fa-video-camera iconTitle'
  },
  component: () => import('@/views/Application.vue'),
  hidden: false,
  children: [
    {
      path: '/nationalAssess',
      name: '评审库',
      hidden: false,
      meta: {
        title: '国家评委库',
        level: 2,
        nav: 'nationsJudges',
        role: ['admin', 'topunion'],
        iconClass: 'icon-judges',
        icon: 'fa fa-dashboard iconTitle'
      },
      component: () => import('@/views/compmanage/reviewlibrary')
    },
    {
      path: '/addJudgeToNationsJudges',
      name: 'addJudgeToNationsJudges',
      hidden: true,
      meta: { title: '添加评委', hiddenNav: true, level: 3, nav: 'nationsJudges' },
      component: () => import('@/views/compmanage/peopleManage/sub/judge/add-judge')
    },
    {
      path: '/nationsJudgeDetail/:id',
      name: 'nationsJudgeDetail',
      hidden: true,
      meta: { title: '评委详情', hiddenNav: true, level: 3, nav: 'nationsJudges' },
      component: () => import('@/views/compmanage/peopleManage/sub/judge/add-judge/detail.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/nationsJudges.js